export const getFirstName = ({ name }: { name?: string }): string => (name ?? '').split(' ')[0];

/**
 * Whether an account belongs to Natter staff, based on its email domain.
 *
 * Used to tag RUM/Logs sessions with an `isStaff` flag so internal traffic can be excluded from
 * product analytics. Deliberately returns a boolean (never the email itself) so it is safe to send
 * in production, where account emails are intentionally not forwarded to Datadog.
 */
export const isStaffEmail = (email?: string): boolean => !!email && email.trim().toLowerCase().endsWith('@natter.co');
